import React, {Component} from 'react';
import {
    Grid, Row, Col,
} from 'react-bootstrap';

import {Card} from 'components/Card/Card.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';

import gbutton from 'assets/img/google_signin_button.svg'
import roboto from 'assets/fonts/Roboto-Medium.ttf'

class Login extends Component {
    constructor(props) {
        super(props);
        this.classes = props;
    }

    render() {
        return (
            <div className="content">
                <Grid>
                    <Row>
                        <Col lg={4} sm={4} xs={4}/>
                        <Col lg={4} sm={4} xs={4}>
                            <Card
                                title='Yerd.ly Dashboard'
                                content={
                                    <div style={{textAlign: 'center'}}>
                                        <Button onClick={() => this.props.login()}
                                                style={{
                                                    backgroundColor: '#FFFFFF',
                                                    color: '#000000',
                                                    font: roboto,
                                                    size: '14px',
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                    borderWidth: 0,
                                                }}>
                                            {
                                                <img src={gbutton}
                                                     alt="google_logo"
                                                     style={{
                                                         marginRight: 14,
                                                     }}/>
                                            }
                                            Sign in with Google
                                        </Button>
                                    </div>
                                }/>
                        </Col>
                        <Col lg={4} sm={4} xs={4}/>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx